import { getActiveAdventure } from "../adventure/ActiveAdventure.js";
import { LootTableRegistry } from "./LootTableRegistry.js";
import type { LootTable } from "./lootTable.js";

/**
 * I15a — fetch authored loot tables for the active adventure and
 * register them. Called once during the boot sequence after
 * `mountAdventure` resolves.
 *
 * File layout:
 * `<baseUrl>/data/loot_tables.json` → a flat JSON array of
 * `LootTable` objects. A missing file is tolerated (returns `false`);
 * adventures without authored loot simply have no tables registered.
 */
export async function loadAdventureLootTables(): Promise<boolean> {
  const { baseUrl } = getActiveAdventure();
  const url = `${baseUrl}/data/loot_tables.json`;
  const res = await fetch(url);
  if (!res.ok) return false;
  const data = (await res.json()) as LootTable[];
  LootTableRegistry.registerAll(data);
  return true;
}
